angular.module('impactx.rfx').controller('NumSupplierTextDialogCtrl', [
    '$mdDialog',
    '$scope',
    'themeFactory',
    'TranslationService',
    'label',
    NumSupplierTextDialogCtrl]);

function NumSupplierTextDialogCtrl($mdDialog, $scope, themeFactory, TranslationService, label) {
    var self = this;
    $scope.numSupplierText = {label: label};
    $scope.abortLabel = TranslationService.get("abort");
    $scope.acceptLabel = TranslationService.get("accept");
    $scope.theme = themeFactory.getTheme();

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.answer = function () {
        $mdDialog.hide({
            text: $scope.numSupplierText.selected.value
        });
    };
}